import { createFileRoute } from "@tanstack/react-router";
import FindDoctorSpecializingInChronicPainPage from "@/pages/articles/FindDoctorSpecializingInChronicPainPage";
export const Route = createFileRoute(
  "/how-can-i-find-a-doctor-who-specializes-in-chronic-pain",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Find a Chronic Pain Doctor | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how to find board-certified chronic pain specialists, interventional pain clinics, and advanced treatments like Ketamine infusions in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Find a Chronic Pain Doctor | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how to find board-certified chronic pain specialists, interventional pain clinics, and advanced treatments like Ketamine infusions in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-can-i-find-a-doctor-who-specializes-in-chronic-pain",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-can-i-find-a-doctor-who-specializes-in-chronic-pain",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FindDoctorSpecializingInChronicPainPage />;
}
